<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Work Anniversary Report</h5>
  </div>
  <div class="container pt-3" id="mainContent" *ngIf="workAnniversaryReport.length>0">
<div class="row justify-content-center text-center">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
<div class="row mt-2 justify-content-center text-center">
  <span class="bg-theme-title">Work Anniversary Report</span>
</div>
<div class="row col-md-12 mt-3">
  <table class="table table-bordered table-sm" >
    <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Branch</th>
        <th>Type</th>
        <th>Service Vertical</th>
        <th>Reporting Partner</th>
        <th>Joining Date</th>
      </tr>
    </thead>
    <tbody *ngFor="let data of workAnniversaryReport;let i=index;">
      <td>{{i+1}}</td>
      <td>{{data.name}}</td>
      <td>{{data.branch}}</td>
      <td >{{data.type}}</td>
      <td>{{data.serviceVertical}}</td>
      <td>{{data.reportingPartner}}</td>
      <td>{{data.joiningDate |date: "dd-MM-yyyy"}}</td>
    </tbody>

  </table>
</div>
</div>
</div>